import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function urlValidator(allowedHosts?: string[]): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value?.trim();
		if (!value) {
			return null;
		}

		const urlPattern = /^(https?:\/\/)?(www\.)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;

		if (!urlPattern.test(value)) {
			return { invalidUrl: true };
		}

		if (allowedHosts?.length) {
			try {
				const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
				const hostname = url.hostname.toLowerCase();
				const isAllowedHost = allowedHosts.some(host => {
					const allowedHost = host.toLowerCase();
					return (hostname === allowedHost || hostname.endsWith(`.${allowedHost}`));
				});

				if (!isAllowedHost) {
					return { invalidDomain: true };
				}
			} catch {
				return { invalidUrl: true };
			}
		}

		return null;
	};
}


export function companyAboutValidator(minLength = 2, maxLength = 1000): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;
		if (value === null || value === undefined || value === '') {
			return null;
		}

		const trimmedValue = value.trim();

		if (!trimmedValue) {
			return { whitespace: true };
		}

		if (trimmedValue.length < minLength) {
			return {
				minLengthAbout: {
					requiredLength: minLength,
					actualLength: trimmedValue.length
				}
			};
		}

		if (trimmedValue.length > maxLength) {
			return {
				maxLengthAbout: {
					requiredLength: maxLength,
					actualLength: trimmedValue.length
				}
			};
		}

		// if (/\s{2,}/.test(trimmedValue)) {
		// 	return { excessiveSpaces: true };
		// }

		return null;
	};
}